import "./index.css";
import SvgComponent from "../SVGComponent";
import ICONS from "../../../assets/Icons/index.js";
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @param {Object} props
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {boolean} props.state - is this switch enabled or not
 * @param {boolean} props.title - title for image
 * @returns {JSX.Element}
 */
const CommonSnoozeToggle = ({ state, isDisabled, handleClick, title }) => {
  return (
    <div
      onClick={(e) => {
        if (!isDisabled) handleClick(e);
      }}
      className={`relative bg-primary-bg w-multiandsingleview-btn-width ${isDisabled ? "cursor-not-allowed opacity-light-opacity" : "cursor-pointer global-hover-white"}  z-z-index-base rounded-border-radius-md`}
    >
      <div
        className={`absolute h-height-full rounded-border-radius-md bg-text-primary z-z-index-base ${state ? "animate-right" : "animate-left"} `}
      ></div>
      <div className="p-padding-button-m flex gap-x-gap-button-l">
        <div
          title={state ? title : ""}
          className="z-z-index-content"
        >
          <SvgComponent
            height="var(--icon-sm)"
            width="var(--icon-sm)"
            color={state ? "var(--text-primary)" : "var(--primary-bg)"}
            url={ICONS?.UNSNOOZE}
            alt="Unsnooze"
          />
        </div>
        <div
          title={state ? "" : title}
          className="z-z-index-content"
        >
          <SvgComponent
            height="var(--icon-sm)"
            width="var(--icon-sm)"
            color={state ? "var(--primary-bg)" : "var(--text-primary)"}
            url={ICONS?.SNOOZE}
            alt="Snooze"
          />
        </div>
      </div>
    </div>
  );
};

export default CommonSnoozeToggle;
